<button
  mat-icon-button
  [matTooltip]="'UNANSWERED_SMS.RELOAD_BUTTON_TOOLTIP' | translate"
  matTooltipPosition="right"
  [disabled]="isReloadingTable()"
  (click)="triggerTableReload()"
>
  <mat-icon class="small" [ngClass]="{ spin: isReloadingTable() }"> refresh </mat-icon>
</button>

<div class="sms-list">
  <mat-table matSort multiTemplateDataRows [dataSource]="eventGroups$">
    <mat-header-row class="d-none d-md-flex" *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns"
      [ngClass]="{ 'expanded-source-row': row?.collapsed }"
    ></mat-row>
    <mat-row
      *matRowDef="let row; columns: ['expandedSMSDetail']"
      [class.expanded-row--open]="!row?.collapsed"
      class="expanded-row"
    >
    </mat-row>

    <ng-container matColumnDef="from">
      <mat-header-cell *matHeaderCellDef>
        {{ 'UNANSWERED_SMS.TABLE_COLUMNS.FROM' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <a [routerLink]="'/employees/' + row.employee.id" [queryParamsHandling]="'preserve'">
          {{ row.employee | personName }}
        </a>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="nr">
      <mat-header-cell *matHeaderCellDef>
        {{ 'UNANSWERED_SMS.TABLE_COLUMNS.NR' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div>
          {{ row.employee?.mobileNumber }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="received">
      <mat-header-cell *matHeaderCellDef>
        {{ 'UNANSWERED_SMS.TABLE_COLUMNS.RECEIVED' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div>
          {{ row.events[0]?.dateTimeStart | date: 'dd/MM/yyyy HH:mm' }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef>
        {{ 'UNANSWERED_SMS.TABLE_COLUMNS.ACTIONS' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <button mat-icon-button (click)="sendSMS(row.events[0])">
          <mat-icon> sms </mat-icon>
        </button>
        <button mat-icon-button (click)="toggleRow(row)">
          <mat-icon class="expand-arrow" [class.expand-arrow--expanded]="!row?.collapsed">
            expand_more
          </mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="expandedSMSDetail">
      <mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
        <div class="sms__groups">
          @for (event of row.events; track event.id) {
            <div
              class="sms__groups__content"
              [matTooltip]="event.message"
              matTooltipPosition="left"
            >
              <mat-icon> sms </mat-icon>
              <div class="sms__groups__content__subject__group">
                @if (event.sourceType === sourceTypeEnum.CANDIDATE) {
                  <div class="sms__groups__content__subject">
                    {{ 'UNANSWERED_SMS.TABLE_COLUMNS.FROM' | translate }}
                  </div>
                } @else {
                  <div class="sms__groups__content__subject">
                    {{ 'UNANSWERED_SMS.TABLE_COLUMNS.TO' | translate }}
                  </div>
                }

                <div class="sms__groups__content__subject">
                  {{ event.employee?.mobileNumber }}
                </div>

                @if (event.status && event.status !== 'SENDING') {
                  <div class="sms__groups__content__subject">
                    - {{ 'UNANSWERED_SMS.STATUS.' + event.status | translate }}
                  </div>
                }

                <div class="sms__groups__content__subject">
                  {{ event.authorUser | personName }}
                </div>
              </div>
              <div class="sms__groups__content__subject__period">
                {{ event.dateTimeStart | date: 'dd/MM/yyyy HH:mm' }}
              </div>
            </div>
          }
        </div>
      </mat-cell>
    </ng-container>

    <ng-template matNoDataRow>
      <div class="d-flex justify-content-center align-items-center p-5">
        {{ 'UNANSWERED_SMS.EMPTY_LIST' | translate }}
      </div>
    </ng-template>
  </mat-table>
</div>
